import React from 'react';
import Input from '../components/Input';
import { getCities } from '../api/api';
import AsyncInput from '../components/AsyncInput';
import Dropdown from '../components/Dropdown';
import { TIMEZONES } from '../features/Objects/constants';

const ObjectEditor = ({ setObject, object }) => {
  const loadOptions = async (inputValue) => {
    const cities = await getCities({ city_name: inputValue });
    return cities.map((city) => ({
      label: `${city?.name}, ${city?.region_name ?? ''}`,
      value: city.id,
    }));
  };
  const defaultValue = object?.city_id ? { label: object?.city_name, id: object?.city_id } : '';

  return (
    <>
      <AsyncInput
        defaultOptions={true}
        classContainer={'rounded-full px-1 mb-2'}
        fontSize={'16px'}
        borderRadius={'40px'}
        label="Город"
        id="city"
        placeholder={'Введите город'}
        defaultValue={defaultValue}
        handleSearch={(value) => setObject({ ...object, city_id: value })}
        loadOptions={loadOptions}
      />
      <Input
        classContainer={'w-full'}
        value={object.address}
        inputCb={(e) => setObject({ ...object, address: e.target.value })}
        label="Адрес"
        id="addr"
        type="text"
        placeholder={'ул. Окружная, д 6'}></Input>
      <Input
        classContainer={'w-full mt-4'}
        value={object.apartment}
        inputCb={(e) => setObject({ ...object, apartment: e.target.value })}
        label="Номер квартиры"
        id="apartment"
        type="text"
        placeholder={'96'}
      />
      <Dropdown
        className={'mt-4'}
        label={'Часовой пояс'}
        options={TIMEZONES}
        value={object?.time_zone}
        inputCb={(e) => setObject({ ...object, time_zone: e.target.value })}
        id="timezone"
        valkey="val"
        optkey="opt"
      />
    </>
  );
};

export default ObjectEditor;
